module.exports = __webpack_public_path__ + "static/media/ends_with_n.1da48db1.mp3";